import React from 'react'
import { bool, func } from 'prop-types'
import { ContentWrapper } from '../shared/content-wrapper'
import SignForm from '../shared/sign-form'
import HeadingGamma from '../headings/heading-gamma'
import ResetPasswordForm from './ResetPasswordForm'
import HeadingDelta from '../headings/heading-delta'
import Link from 'react-router-dom/Link'
import withForm from '../../services/password-reset/withResetPasswordForm'

const DecoratedForm = withForm(ResetPasswordForm)

const ResetPassword = props => {
  const { isResetSuccess, isResetFailed, submit } = props
  return (
    <ContentWrapper>
      <SignForm>
        {/*<div className='prominent-icon'>
        <Icon name='warning' />
      </div>*/}
        <HeadingGamma>Reset your password</HeadingGamma>
        {isResetSuccess && (
          <HeadingDelta thin>
            Your password has been reset. You can now login with your new
            credentials.{' '}
            <Link to='/login' className='tiny-link'>
              Proceed to login
            </Link>
          </HeadingDelta>
        )}
        {isResetFailed && (
          <HeadingDelta thin>
            Sorry, but your password could not be saved. Your reset link may
            have been expired.{' '}
            <Link to='/forget-password' className='tiny-link'>
              Try again
            </Link>
          </HeadingDelta>
        )}
        {!isResetFailed && !isResetSuccess && <DecoratedForm submit={submit} />}
      </SignForm>
    </ContentWrapper>
  )
}

ResetPassword.propTypes = {
  isResetSuccess: bool,
  isResetFailed: bool,
  submit: func
}

export default ResetPassword



// WEBPACK FOOTER //
// ./src/ui/forget-password/ResetPassword.js